//定义全局变量
const api_url = 'https://api.mugechun.com/Admin';
// const api_url = 'https://mugechun.api.xiaocx.cc/Admin';
// const api_url = 'http://mugechun.api.xiaocx.my/Admin';
// 统一上传入口（由后端负责转存到阿里云 OSS）
const upload_url = api_url + '/Upload/file';
const token = '';
const user_name = '';
const user_id = 0;
export default {
    upload_url,
    api_url,
    token,
    user_name,
    user_id
}



// WEBPACK FOOTER //
// ./src/util/common.js